import { TitleCasePipe } from '@angular/common';
import { Component, Input, Output, OnChanges, SimpleChanges, ViewChild, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Vendor } from '../../DTO/vendor';
import { PharmacyCRUDModel } from '../../DTO/pharmacy-crud';
import { VendorService } from 'src/app/services/vendorservice';
import { PharmacyService } from '../../../services/pharmacyservice';
import { ConnectionDetails } from '../../DTO/connection-details';

@Component({
  selector: 'app-connection-details',
  templateUrl: './connection-details.component.html',
  styleUrls: ['./connection-details.component.css']
})
export class ConnectionDetailsComponent implements OnChanges {
  missingParameter: boolean = false;
  connectionMessage: string = '';
  isConnectionSuccessful = false;
  isLoading: boolean = false;
  panelOpenState = false;
  form: FormGroup;
  useOkta: boolean = false;
  endpointPropertyName: string;
  endpointFieldControlName: string;
  clearFormFields: boolean = true;
  @Output() connectionStatus = new EventEmitter<{ success: boolean, message: string }>();
  constructor(private pharmacyService: PharmacyService, private vendorService: VendorService) {}

  AuthType: FormControl = new FormControl('BASIC', [Validators.required]);
  BasicEndpointURL: FormControl = new FormControl('');
  OktaEndpointURL: FormControl = new FormControl('');
  OktaMckClientId: FormControl = new FormControl('', [Validators.required]);
  OktaAuthURL: FormControl = new FormControl('');
  OktaClientId: FormControl = new FormControl('');
  OktaClientSecret: FormControl = new FormControl('');
  BasicUserName: FormControl = new FormControl('');
  BasicPassword: FormControl = new FormControl('');//, [Validators.required]);
  HiddenPassword: FormControl = new FormControl('');
  HiddenClientSecret: FormControl = new FormControl('');
  @Input() inputModel: any;

  ngOnInit() {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.form) {
      this.createForm();
    }
    
    // Determine endpoint property
    const endpointKeys = ['PharmacyEndpointURL', 'VendorEndpointURL', 'EndpointURL'];
    this.endpointPropertyName = endpointKeys.find(key => key in this.inputModel);
    
    const hasMinimumFields = Object.keys(this.inputModel).filter(key => this.inputModel[key]).length >= 3;
    const isConnectivitySet = this.inputModel.IsConnectivitySet === true;
    const isVendorConnectionEnabled = this.inputModel.IsVendorConnectionEnabled === true;

    if (hasMinimumFields && isConnectivitySet && !isVendorConnectionEnabled) {
      this.panelOpenState = true;
      this.clearFormFields = false;
      
      const resolvedAuthType = this.inputModel.AuthType?.trim() || 'BASIC';
      this.AuthType.setValue(resolvedAuthType);

      if (resolvedAuthType === 'BASIC') {
        this.endpointFieldControlName = 'BasicEndpointURL';
        this.SetBasicValidation();
      } else if (resolvedAuthType === 'OKTA') {
        this.endpointFieldControlName = 'OktaEndpointURL';
        this.SetOktaValidation();
      }

      this.form.patchValue({
        AuthType: this.inputModel.AuthType?.trim() || 'BASIC',
        'OktaMckClientId': this.inputModel.OktaMckClientId,
        'OktaAuthURL': this.inputModel.OktaAuthURL,
        'OktaClientId': this.inputModel.OktaClientId,
        'OktaClientSecret': this.inputModel.OktaClientSecret,
        'BasicUserName': this.inputModel.BasicUserName,
        'BasicPassword': this.inputModel.BasicPassword,
        'HiddenPassword': this.inputModel.HiddenPassword,
        'HiddenClientSecret': this.inputModel.HiddenClientSecret
      });

      const endpointValue = this.inputModel[this.endpointPropertyName];
      if (endpointValue !== undefined) {
        this.form.get(this.endpointFieldControlName)?.setValue(endpointValue);
      }
      // ✅ Trigger form validity recalculation after patching and setup
      this.form.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    } else {
      this.createForm();
      this.AuthType.setValue('BASIC');
      this.endpointFieldControlName = 'BasicEndpointURL';
      this.SetBasicValidation();
    }

    this.form.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }

  setModelAttributes() {
    if (this.panelOpenState) {
      this.inputModel.AuthType = this.form.get('AuthType')?.value;
      this.inputModel.OktaMckClientId = this.form.get('OktaMckClientId')?.value;
      this.inputModel.OktaAuthURL = this.form.get('OktaAuthURL')?.value;
      this.inputModel.OktaClientId = this.form.get('OktaClientId')?.value;
      this.inputModel.BasicUserName = this.form.get('BasicUserName')?.value;

      // what to do if the user doesn't enter a value from the password or client secret?????? don't send a value to the db???
      this.inputModel.OktaClientSecret = this.form.get('OktaClientSecret')?.value;
      this.inputModel.BasicPassword = this.form.get('BasicPassword')?.value;
      this.inputModel.HiddenPassword = this.form.get('HiddenPassword')?.value;
      this.inputModel.HiddenClientSecret = this.form.get('HiddenClientSecret')?.value;

      if (this.inputModel instanceof Vendor) {
        this.endpointPropertyName = "VendorEndpointURL";
      } else if (this.inputModel instanceof PharmacyCRUDModel) {
        this.endpointPropertyName = "PharmacyEndpointURL";
      }

      if (this.inputModel.AuthType == 'BASIC') {
        this.inputModel[this.endpointPropertyName] = this.form.get('BasicEndpointURL')?.value;
        this.inputModel.OktaClientId = "";
        this.inputModel.OktaClientSecret = "";
        this.inputModel.OktaAuthURL = "";
        this.inputModel.HiddenClientSecret = "";
      }
      else if (this.inputModel.AuthType == 'OKTA') {
        this.inputModel[this.endpointPropertyName] = this.form.get('OktaEndpointURL')?.value;
        this.inputModel.BasicUserName = "";
        this.inputModel.BasicPassword = "";
        this.inputModel.BasicEndpointURL = "";
        this.inputModel.HiddenPassword = "";
      }
    }
  }

  createForm() {
    this.form = new FormGroup({
      BasicEndpointURL: this.BasicEndpointURL,
      OktaEndpointURL: this.OktaEndpointURL,
      OktaMckClientId: this.OktaMckClientId,
      AuthType: this.AuthType,
      OktaAuthURL: this.OktaAuthURL,
      OktaClientId: this.OktaClientId,
      OktaClientSecret: this.OktaClientSecret,
      BasicUserName: this.BasicUserName,
      BasicPassword: this.BasicPassword,
      HiddenPassword: this.HiddenPassword,
      HiddenClientSecret: this.HiddenClientSecret
    });
  }

  get errorMessageForOktaMckClientId(): string {
    const form: FormControl = (this.OktaMckClientId as FormControl);
    return form.hasError('required') ?
      'Mckesson Client ID is required' : ""
  }

  get errorMessageForBasicEndpointURL(): string {
    const form: FormControl = (this.BasicEndpointURL as FormControl);
    return form.hasError('required') ?
      'Endpoint url is required' : ""
  }

  get errorMessageForOktaEndpointURL(): string {
    const form: FormControl = (this.OktaEndpointURL as FormControl);
    return form.hasError('required') ?
      'Endpoint url is required' : ""
  }

  get errorMessageForBasicUserName(): string {
    const form: FormControl = (this.BasicUserName as FormControl);
    return form.hasError('required') ?
      'UserName is required' : ""
  }

  get errorMessageForBasicPassword(): string {
    const form: FormControl = (this.BasicPassword as FormControl);
    return form.hasError('required') ?
      'Password is required' : ""
  }

  get errorMessageForOktaClientId(): string {
    const form: FormControl = (this.OktaClientId as FormControl);
    return form.hasError('required') ?
      'Client id is required' : ""
  }

  get errorMessageForOktaClientSecret(): string {
    const form: FormControl = (this.OktaClientSecret as FormControl);
    return form.hasError('required') ?
      'Client secret is required' : ""
  }

  get errorMessageForOktaAuthURL(): string {
    const form: FormControl = (this.OktaAuthURL as FormControl);
    return form.hasError('required') ?
      'Auth URL is required' : ""
  }

  SetBasicValidation() {
    this.AuthType.setValue('BASIC');
    this.useOkta = false;
    this.OktaAuthURL.clearValidators();
    this.OktaClientId.clearValidators();
    this.OktaClientSecret.clearValidators();
    this.OktaEndpointURL.clearValidators();
    this.BasicUserName.setValidators([Validators.required]);
    if (!this.inputModel.HiddenPassword) {
      this.BasicPassword.setValidators([Validators.required]);
    } else {
      this.BasicPassword.clearValidators();
    }
    this.BasicEndpointURL.setValidators([Validators.required]);
    this.UpdateValidationStatus();
  }

  SetOktaValidation() {
    this.AuthType.setValue('OKTA');
    this.useOkta = true;
    this.BasicUserName.clearValidators();
    this.BasicPassword.clearValidators();
    this.BasicEndpointURL.clearValidators();
    this.OktaAuthURL.setValidators([Validators.required]);
    this.OktaClientId.setValidators([Validators.required]);
    if (!this.inputModel.HiddenClientSecret) {
      this.OktaClientSecret.setValidators([Validators.required]);
    } else {
      this.OktaClientSecret.clearValidators();
    }
    this.OktaEndpointURL.setValidators([Validators.required]);
    this.UpdateValidationStatus();
  }

  UpdateValidationStatus() {
    this.AuthType.updateValueAndValidity();
    this.BasicUserName.updateValueAndValidity();
    this.BasicPassword.updateValueAndValidity();
    this.BasicEndpointURL.updateValueAndValidity();
    this.OktaAuthURL.updateValueAndValidity();
    this.OktaClientId.updateValueAndValidity();
    this.OktaClientSecret.updateValueAndValidity();
    this.OktaEndpointURL.updateValueAndValidity();
  }

  onUseOkta(event: any) {
    if (event.value != 'BASIC') {
      this.SetOktaValidation();
      this.endpointFieldControlName = 'OktaEndpointURL'; // Update field name
      if (this.clearFormFields) {
        this.form.get('OktaAuthURL')?.setValue("");
        this.form.get('OktaClientId')?.setValue("");
        this.form.get('OktaClientSecret')?.setValue("");
        this.form.get('OktaEndpointURL')?.setValue("");
      }
    }
    else {
      this.SetBasicValidation();
      this.endpointFieldControlName = 'BasicEndpointURL'; // Update field name
      if (this.clearFormFields) {
        this.form.get('BasicUserName')?.setValue("");
        this.form.get('BasicPassword')?.setValue("");
        this.form.get('BasicEndpointURL')?.setValue("");
      }
    }
  }

  getBasicPassword(): string {
    return this.form.get('BasicPassword')?.value?.trim() 
        ? this.form.get('BasicPassword')?.value 
        : this.inputModel.HiddenPassword;
  }

  getOktaClientSecret(): string {
    return this.form.get('OktaClientSecret')?.value?.trim()
        ? this.form.get('OktaClientSecret')?.value
        : this.inputModel.HiddenClientSecret;
  }

  testConnection() {
    this.missingParameter = false;
    this.connectionMessage = '';

    this.form.updateValueAndValidity();

    setTimeout(() => {
        const specialCharPattern = /[$%&]/;

        // List of form control names to validate
        const fieldsToCheck = [
            'AuthType',
            'EndpointURL',
            'RequestXML',
            'BasicUserName',
            'OktaClientId',
            'OktaClientSecret',
            'OktaAuthURL',
            'BasicEndpointURL',
            'OktaEndpointURL'
        ];
      
        for (const field of fieldsToCheck) {
            const fieldValue = this.form.get(field)?.value?.trim() || '';
            if (specialCharPattern.test(fieldValue)) {
                this.isLoading = false;
                this.isConnectionSuccessful = false;
                this.connectionMessage = `Connectivity Failed: Special characters ($, %, &) are not allowed in ${field}`;
                this.connectionStatus.emit({ success: false, message: this.connectionMessage });
                return;
            }
        }
        
        const endpointURL = this.form.get(this.endpointFieldControlName)?.value?.trim() || '';

        let connectionDetails: ConnectionDetails;
        if (this.form.get('AuthType')?.value === 'OKTA') {
            connectionDetails = new ConnectionDetails(
                'OKTA',
                endpointURL,
                '',
                '', 
                '', 
                this.form.get('OktaClientId')?.value || '',
                this.form.get('OktaClientSecret')?.value || this.form.get('HiddenClientSecret')?.value,
                this.form.get('OktaAuthURL')?.value || ''
            );

            if (!connectionDetails.AuthURL || !connectionDetails.ClientID || !connectionDetails.ClientSecret) {
                this.missingParameter = true;
            }
        } else {
            connectionDetails = new ConnectionDetails(
                'BASIC',
                endpointURL,
                '',
                this.form.get('BasicUserName')?.value || '',
                this.form.get('BasicPassword')?.value || this.form.get('HiddenPassword')?.value,
                '', 
                '', 
                ''  
            );

            if (!connectionDetails.UserName || !connectionDetails.Password) {
                this.missingParameter = true;
            }
        }

        if (this.missingParameter) {
            this.isLoading = false;
            this.isConnectionSuccessful = false;
            this.connectionMessage = 'Connectivity Failed: A required parameter is missing';
            this.connectionStatus.emit({ success: false, message: this.connectionMessage });
            return;
        }

        this.isLoading = true;

        let serviceToUse = this.endpointPropertyName.toLowerCase().includes('pharmacy') ? 
            this.pharmacyService : 
            this.vendorService;

        if (!serviceToUse) {
            this.isLoading = false;
            this.connectionMessage = 'Connectivity Failed: Invalid service selection';
            this.isConnectionSuccessful = false;
            this.connectionStatus.emit({ success: false, message: this.connectionMessage });
            return;
        }

        serviceToUse.testConnection(connectionDetails).subscribe(res => {
            this.isLoading = false; 
            if (res.ResponseStatus == '1') {
                this.connectionMessage = 'Connectivity Success';
                this.isConnectionSuccessful = true;
                this.connectionStatus.emit({ success: true, message: this.connectionMessage });
            } else {
                this.connectionMessage = res.ResponseMessage || 'Connectivity Failed';
                this.isConnectionSuccessful = false;
                this.connectionStatus.emit({ success: false, message: this.connectionMessage });
            }
        });
    }, 0); 
  }
}
